export const isDev =
  window.location.href.startsWith("https://app.ses-mams-dev.net/") ||
  window.location.href.startsWith("http://127.0.0.1");
